import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { IMiscSlice } from './types';

const initialState: IMiscSlice = {
  isDbooProfileUpdated: false,
  isWatchlistProfileUpdated: false,
  isDataCollectionModalClosed: false,
};

const miscSlice = createAppSlice({
  name: 'misc',
  initialState,
  reducers: {
    setIsDbooProfileUpdated(state, action: PayloadAction<boolean>) {
      state.isDbooProfileUpdated = action.payload;
    },
    setIsWatchlistProfileUpdated(state, action: PayloadAction<boolean>) {
      state.isWatchlistProfileUpdated = action.payload;
    },
    setIsDataCollectionModalClosed(state, action: PayloadAction<boolean>) {
      state.isDataCollectionModalClosed = action.payload;
    },
  },
});

export const {
  setIsDbooProfileUpdated,
  setIsWatchlistProfileUpdated,
  setIsDataCollectionModalClosed,
} = miscSlice.actions;
export default miscSlice.reducer;
